<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";

  // Das ce composant on passe juste les labels et les series pour une courbe !!
  export let chartType = "line";
  export let chartDataLabels = "";
  export let chartDatasets;
  export let chartLabelLine = "label defaut...";

  let ctx;
  let chartCanvas;

  onMount(async () => {
    // console.log("MD label : " + chartDataLabels);

    ctx = chartCanvas.getContext("2d");
    var chart = new Chart(ctx, {
      type: chartType,
      data: {
        labels: chartDataLabels,
        datasets: [
          {
            label: chartLabelLine,
            backgroundColor: "rgb(255, 99, 132)",
            borderColor: "rgb(255, 99, 132)",
            data: chartDatasets,
          },
        ],
      },
    });
  });
</script>

<canvas bind:this={chartCanvas} id="myChart" />
